import React from "react"
import Skeleton from "react-loading-skeleton"
import "react-loading-skeleton/dist/skeleton.css"

function SkeletonHandler() {
  return (
    <div>
      <Skeleton height={100} />
      <Skeleton height={100} />
    </div>
  )
}

export default SkeletonHandler
